import BaseGameFactory from "../core/src/factories/BaseGameFactory";
import Settings from "../src/base/ui/Settings";
import BaseSettings from "../core/src/ui/BaseSettings";
import UIDesktopView from "../src/base/ui/UIDesktop";
import GameModel from "../core/src/model/GameModel";
// import UIMobileView from "../src/base/ui/UIMobile";
import BaseUI from "../core/src/ui/BaseUI";
// import AbstractPopup from "../core/src/ui/AbstractPopup";
// import BetPopup from "../src/base/ui/BetPopup";
// import AutoplayPopup from "../src/base/ui/AutoplayPopup";


export class GameFactory extends BaseGameFactory{

    protected getSettings(): BaseSettings {
        return new Settings();
    }

    protected getUIView(): BaseUI {
        if (GameModel.isMobile()) {
            // return new UIMobileView()
            return new UIDesktopView();
        } else {
            return new UIDesktopView();
        }
    }

    // protected getBetPopup(): AbstractPopup {
    //     return new BetPopup();
    // }

    // protected getAutoplayPopup(): AbstractPopup {
    //     return new AutoplayPopup();
    // }

}

export default GameFactory;
